import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // scroll to top (left) of page
        window.scrollTo(0, 0); 
    }, [pathname]); // re-run effect whenever the pathname (route) changes

    // no ui
    return null; 
}
